export const columnarOption = {
  color: ["#42D3C6"],
  xAxis: {
    type: "category",
    data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
  },
  yAxis: {
    type: "value",
  },
  series: [
    {
      data: [120, 200, 150, 80, 70, 110, 130],
      barWidth: "35%",
      itemStyle: {
        barBorderRadius: 5,
      },
      type: "bar",
      label: {
        show: true,
        position: "top",
        color: "#777777",
      },
    },
  ],
};
